"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSnackbarMessage = void 0;
var _lodash = _interopRequireDefault(require("lodash.difference"));
const getSnackbarMessage = ({
  lastUsedProductCodeInLists,
  selectedListIds,
  translations
}) => {
  const addedListIds = (0, _lodash.default)(selectedListIds, lastUsedProductCodeInLists);
  const removedListIds = (0, _lodash.default)(lastUsedProductCodeInLists, selectedListIds);
  if (addedListIds.length > 0 && removedListIds.length > 0) {
    return translations.listsWereUpdated;
  }
  if (addedListIds.length > 0) {
    return translations.productWasAddedToTheLists;
  }
  return translations.productWasRemovedFromTheLists;
};
exports.getSnackbarMessage = getSnackbarMessage;
